import ReactPlayer from 'react-player';
import ch3_img1 from 'assets/knowledge/ch3_img1.png';
import ch3_img2 from 'assets/knowledge/ch3_img2.png';
import ch3_img3 from 'assets/knowledge/ch3_img3.png';
import ch3_img03 from 'assets/knowledge/ch3_img03.png';
import ch3_img4 from 'assets/knowledge/ch3_img4.png';
import ch3_img5 from 'assets/knowledge/ch3_img5.png';
import ch3_img6 from 'assets/knowledge/ch3_img6.png';
import ch3_img7 from 'assets/knowledge/ch3_img7.png';
import ch3_img8 from 'assets/knowledge/ch3_img8.png';
import ch3_img9 from 'assets/knowledge/ch3_img9.png';
import ch3_img10 from 'assets/knowledge/ch3_img10.png';

const Chapter3 = () => {
  return <div>
  <h2>Fahrzeuge anlegen und löschen</h2>
  <ReactPlayer url="https://youtu.be/Ng1X9Ty7uZg" controls width="100%" />
  <h3>1. Einzelnes Fahrzeug anlegen</h3>
  <p>Zuerst geht man in eine beliebige Flotte. Per Klick auf „LKW / Anhänger hinzufügen“ öffnet sich ein neues Fenster. Auf dem geöffneten Reiter „Einzeln“ kann man manuell Fahrzeuge hinzufügen. Dafür muss man einfach alle Pflichtfelder (mit * markiert) ausfüllen und auf „Hinzufügen“ klicken. Wenn möglich sollte man auch die optionalen Felder ausfüllen, um sich später Zeit zu sparen.</p>
  <p> <u>Was ist eine FIN?</u></p>
  <p>Jedes Kraftfahrzeug verfügt über eine Fahrzeugidentifikationsnummer, die eine eindeutige Zuordnung des Fahrzeugs zu Hersteller, Modell usw. aufzeigt. Früher auch als Fahrgestellnummer bezeichnet, dient sie sozusagen als „Ausweis“ des Fahrzeugs</p>

      <p>
        Nach einem Klick auf „Hinzufügen“ wird das Fahrzeug nun in die zuvor
        ausgewählte Flotte hochgeladen.
      </p>

      <img src={ch3_img1} alt='CO2OPT Übersicht1' />
      <p>
        Wenn beim manuellen Hochladen die Reifengrößen und Achskonfiguration
        nicht angegeben werden, müssen Sie das Fahrzeug zu einem späteren
        Zeitpunkt noch manuell in finaler Version konfigurieren, bis auch Reifen
        dem Fahrzeug hinzugefügt werden können. Es empfiehlt sich also, stets
        alle verfügbaren Felder direkt beim Hochladen auszufüllen.{' '}
      </p>
      <p>
        Um den richtigen Achsentypen auswählen zu können, muss man zuerst auf
        die vorher eingestellte Achskonfiguration klicken. Danach kann man dann
        den richtigen Achsentyp auswählen.
      </p>
      <img src={ch3_img2} alt='CO2OPT Übersicht2' />
      <p>Als nächstes wählt man die richtigen Reifengrößen aus.</p>
      <img src={ch3_img03} alt='CO2OPT Übersicht3' />
      <p>
        Kilometerstand, Inspektionstermin und Sicherheitsprüfung sind hier
        wieder optional und können übersprungen werden.{' '}
      </p>
      <img src={ch3_img3} alt='CO2OPT Übersicht4' />
      <p>
        Zum Schluss muss man nur noch auf "Bestätigen" klicken. Dann kann man
        den Reifenaufbau des Fahrzeugs schon sehen. Hätte man schon gleich bei
        der Fahrzeugerstellung die Felder zu Achsentyp und Reifengröße
        ausgefüllt, dann hätte man direkt diese Ansicht gehabt.
      </p>
      <img src={ch3_img4} alt='CO2OPT Übersicht5' />

      <h3>2. Hinzufügen mehrerer Fahrzeuge</h3>
      <p>
        Um jetzt mehrere Fahrzeuge bzw. eine Fahrzeugliste hinzuzufügen, klickt
        man erneut auf „LKW / Anhänger hinzufügen“ und wechselt dann oben in den
        zweiten Tab „Mehreren“. In der neuen Ansicht können Sie nun
        Beispieldateien im Excel- oder CSV-Format herunterladen und bearbeiten.
      </p>
      <img src={ch3_img5} alt='Dashboard Ansicht6' />
      <img src={ch3_img6} alt='Dashboard Ansicht7' />

      <p>
        Sobald die Fahrzeugliste erstellt wurde, kann man diese per Klick auf
        "durchsuchen“ oder alternativ per Drag & Drop auswählen und über die
        Schaltfläche „Hochladen“ dem Fuhrpark hinzufügen.
      </p>
      <p>
        Hinweis: Unsere vordefinierte Formatierung innerhalb der Datei muss für
        einen reibungslosen Upload zwingend beibehalten werden. Dies gilt auch
        für die Interpunktion.
      </p>
      <p>
        Sollten Fehler beim Hochladen festgestellt werden, wird einem eine
        entsprechende Fehlermeldung angezeigt und man kann sich optional eine
        „Download Zusammenfassung“ herunterladen, wenn zumindest ein teilweiser
        Upload möglich war. Überall wo „Success“ steht, wurde das Fahrzeug
        erfolgreich hochgeladen. Wenn Fahrzeuge rot markiert wurden und „Fail“
        dasteht, dann wurde es nicht hochgeladen. Hier kann es zum Beispiel
        sein, dass es diesen Fahrzeugnamen, die FIN oder das Kennzeichen schon
        gibt. Wenn man also Listen hat, auf denen auch schon bereits
        hochgeladene Fahrzeuge drauf sind, muss man sie nicht aussortieren, weil
        sie automatisch nicht hochgeladen werden.
      </p>

      <img src={ch3_img7} alt='Flottenübersicht8' />

      <h3>3. Löschen von Fahrzeugen</h3>
      <h3>3.1 In der Fahrzeugansicht</h3>

      <p>
        Wenn man jetzt das Fahrzeug wieder löschen möchte, klickt man oben
        rechts auf das Mülltonnensymbol.{' '}
      </p>
      <img src={ch3_img8} alt='Flottenübersicht9' />

      <p>
        Damit man Fahrzeuge nicht aus Versehen löscht muss man immer nochmal den
        Fahrzeugnamen eintippen. Nach dem Klick auf „Löschen“ ist das Fahrzeug
        samt aller derzeit montierter Reifen dann nun auch schon gelöscht.
      </p>
      <img src={ch3_img9} alt='Flottenübersicht10' />
      <h3>3.2 In der Flottenansicht</h3>

      <p>
        Es gibt noch eine zweite Möglichkeit ein Fahrzeug zu löschen, und zwar
        direkt in der Flotte. Hierfür muss man nur auf die 3 Punkte ganz rechts
        klicken und dann „Löschen“ auswählen. Dann muss man wieder, wie auch
        vorher den Namen eintippen, und dann auf „Löschen“ klicken.
      </p>
      <img src={ch3_img10} alt='Flottenübersicht100' />
    </div>
};

export default Chapter3;
